/* eslint-disable no-console */

import { register } from 'register-service-worker'


if (process.env.NODE_ENV === 'production') {//cambiar esto cuando se vaya a producción

  self.addEventListener('push', function(e) {

    
  });

  // Cuando el service worker nuevo toma el control (gracias a skipWaiting +
  // clientsClaim en vue.config.js), el JS que ya esta cargado en memoria
  // sigue siendo el viejo hasta la proxima navegacion. Sin este recargo
  // automatico, alguien con la app ya abierta se queda en el codigo viejo
  // indefinidamente -- eso fue justo lo que dejo a los vendedores sin poder
  // entrar cuando se desplegaron las reglas nuevas: su telefono tenia la
  // app abierta con el login viejo (sin sesion), que las reglas nuevas
  // bloquean.
  let recargando = false
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (recargando) return
      recargando = true
      window.location.reload()
    })
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
      
    
    },
    registered () {
      //console.log('Service worker has been registered.')
      
      
    },
    cached () {
      //console.log('Content has been cached for offline use.')
    },
    updatefound () {
      //console.log('New content is downloading.')
    },
    updated () {
      //console.log('New content is available; please refresh.')
    },
    offline () {
      //console.log('No internet connection found. App is running in offline mode.')
      
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }

    
  })

}
